import { c as _c } from "react/compiler-runtime";
import { useTranslation } from "react-i18next";
import { Button } from "@osmix/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@osmix/ui/dialog";
type Props = {
  open: boolean;
  title: string;
  description?: string;
  confirmLabel?: string;
  cancelLabel?: string;
  confirmVariant?: "default" | "destructive";
  onConfirm: () => void;
  onClose: () => void;
  busy?: boolean;
  children?: React.ReactNode;
};
export function ConfirmDialog(t0) {
  const $ = _c(35);
  const {
    open,
    title,
    description,
    confirmLabel,
    cancelLabel,
    confirmVariant: t1,
    onConfirm,
    onClose,
    busy,
    children
  } = t0;
  const confirmVariant = t1 === undefined ? "default" : t1;
  const {
    t
  } = useTranslation();
  let t2;
  if ($[0] !== onClose) {
    t2 = next => {
      if (!next) {
        onClose();
      }
    };
    $[0] = onClose;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== title) {
    t3 = <DialogTitle>{title}</DialogTitle>;
    $[2] = title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== description) {
    t4 = description && <DialogDescription>{description}</DialogDescription>;
    $[4] = description;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <DialogHeader>{t3}{t4}</DialogHeader>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== cancelLabel || $[10] !== t) {
    t6 = cancelLabel ?? t("confirm.cancel");
    $[9] = cancelLabel;
    $[10] = t;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== busy || $[13] !== onClose || $[14] !== t6) {
    t7 = <Button variant="outline" onClick={onClose} disabled={busy}>{t6}</Button>;
    $[12] = busy;
    $[13] = onClose;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== confirmLabel || $[17] !== t) {
    t8 = confirmLabel ?? t("confirm.ok");
    $[16] = confirmLabel;
    $[17] = t;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  let t9;
  if ($[19] !== busy || $[20] !== confirmVariant || $[21] !== onConfirm || $[22] !== t8) {
    t9 = <Button variant={confirmVariant} onClick={onConfirm} disabled={busy}>{t8}</Button>;
    $[19] = busy;
    $[20] = confirmVariant;
    $[21] = onConfirm;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t7 || $[25] !== t9) {
    t10 = <DialogFooter>{t7}{t9}</DialogFooter>;
    $[24] = t7;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== children || $[28] !== t10 || $[29] !== t5) {
    t11 = <DialogContent>{t5}{children}{t10}</DialogContent>;
    $[27] = children;
    $[28] = t10;
    $[29] = t5;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== open || $[32] !== t11 || $[33] !== t2) {
    t12 = <Dialog open={open} onOpenChange={t2}>{t11}</Dialog>;
    $[31] = open;
    $[32] = t11;
    $[33] = t2;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  return t12;
}